module.exports = __webpack_public_path__ + "img/icon116.b81b4ef4.png";